import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-38">
      <button className="w-full py-4 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-39">
        <span className="font-bold text-[#111827] pr-4" data-id="element-40">{question}</span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-[#E6007A] flex-shrink-0" data-id="element-41" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-42" />}
      </button>
      {isOpen && <div className="pb-4 text-[#4B5563] text-sm leading-relaxed" data-id="element-43">
          {answer}
        </div>}
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Funciona solo con cable USB?',
    answer: 'No, tiene sistema dual. Podés usarlo enchufado con el cable USB (incluido) o con 3 pilas AA (no incluidas) para hacerlo portátil.'
  }, {
    question: '¿Las luces se pueden usar por separado?',
    answer: 'Sí, con el botón B podés ir cambiando entre colores individuales (rojo, verde, azul, blanco) o combinarlos como más te guste.'
  }, {
    question: '¿La función giratoria se puede apagar?',
    answer: 'Sí, el botón C activa o desactiva el motor de rotación. Puede quedar fijo proyectando en el techo.'
  }, {
    question: '¿Es apto para habitaciones infantiles?',
    answer: 'Totalmente. Es de plástico resistente, no calienta y la luz es LED de bajo consumo, segura para la vista de los chicos.'
  }, {
    question: '¿Proyecta solo en el techo?',
    answer: 'Proyecta en 360 grados, cubriendo techo y paredes dependiendo de dónde lo ubiques en la habitación.'
  }, {
    question: '¿Incluye pilas?',
    answer: 'No, las 3 pilas AA no están incluidas. El cable USB sí está incluido.'
  }, {
    question: '¿Tiene garantía?',
    answer: 'Sí, ofrecemos 180 días de garantía con cambio directo por fallas de fábrica.'
  }];
  return <Section background="gray" data-id="element-44">
      <h2 className="text-2xl md:text-3xl font-bold text-[#111827] mb-8 text-center" data-id="element-45">
        Preguntas Frecuentes
      </h2>
      <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8" data-id="element-46">
        {faqs.map((faq, idx) => <FAQItem key={idx} {...faq} data-id="element-47" />)}
      </div>
    </Section>;
}